/** Dutch is the source of truth; en.ts is typed against these keys. */
export const nl = {
  app_name: 'Streepaf',
  home_title: 'Maak een lijst. Deel de link. Streep af.',
  home_sub: 'Zonder account. Samen, meteen live.',
  home_new: 'Nieuwe lijst',
  home_new_busy: 'Bezig…',
  home_your_lists: 'Jouw lijsten',
  home_your_lists_hint: 'Deze staan alleen op dit apparaat.',
  home_templates: 'Beginnen met een sjabloon',
  home_how: 'Hoe werkt het?',
  home_step_1_title: 'Maak',
  home_step_1_body: 'Eén tik en je lijst bestaat. Geen account, geen e-mailadres.',
  home_step_2_title: 'Deel',
  home_step_2_body: 'Stuur de link door. Iedereen die hem heeft, kan meedoen.',
  home_step_3_title: 'Streep af',
  home_step_3_body: 'Wat de één afstreept, ziet de ander meteen.',
  home_privacy_title: 'Privacy',
  home_privacy_body:
    'Er zijn geen accounts. Je lijst is te bereiken via een geheime link, dus deel die alleen met mensen die mee mogen doen. Lijsten waar een jaar lang niets mee gebeurt, worden automatisch verwijderd.',
  home_devs: 'Voor ontwikkelaars en agents: API, OpenAPI en MCP',
  remove: 'Verwijderen',
  remove_from_device: 'Uit dit overzicht halen',
  role_edit: 'Bewerken',
  role_view: 'Alleen lezen',
  unnamed: 'Naamloze lijst',

  list_title_placeholder: 'Naam van je lijst',
  add_description: 'Beschrijving toevoegen',
  description_placeholder: 'Waar gaat deze lijst over?',
  add_item_placeholder: 'Item toevoegen…',
  add_item: 'Item toevoegen',
  progress: '{checked} van {total} afgestreept',
  progress_done: 'Alles afgestreept',
  empty_title: 'Nog niks om af te strepen',
  empty_body: 'Tip: plak een hele lijst regels om ze in één keer toe te voegen.',
  all_done_body: 'Klaar. Iets vergeten? Voeg het hieronder toe.',
  completed_group: 'Afgestreept ({count})',
  completed_hidden: '{count} afgestreept — tonen',
  section_add: 'Sectie toevoegen',
  section_placeholder: 'Naam van de sectie',

  item_edit: 'Bewerken',
  item_note: 'Notitie',
  item_note_placeholder: 'Notitie bij dit item',
  item_quantity: 'Aantal',
  item_quantity_placeholder: 'bijv. 500 g',
  item_claim: 'Wie neemt dit mee?',
  item_claim_release: 'Toch niet',
  item_delete: 'Verwijderen',
  item_move_up: 'Omhoog',
  item_move_down: 'Omlaag',
  item_menu: 'Meer voor dit item',
  drag_handle: 'Sleep om te verplaatsen',

  menu: 'Menu',
  menu_share: 'Delen',
  menu_copy_text: 'Kopieer als tekst',
  menu_clear_completed: 'Afgestreepte items wissen',
  menu_uncheck_all: 'Alles uitvinken',
  menu_sort_alpha: 'Sorteer A→Z',
  menu_duplicate: 'Dupliceren',
  menu_copy_to_own: 'Kopieer naar mijn eigen lijst',
  menu_export_md: 'Exporteer als Markdown',
  menu_print: 'Afdrukken',
  menu_view: 'Weergave',
  menu_hide_completed: 'Verberg afgestreept',
  menu_language: 'Taal',
  menu_theme: 'Thema',
  menu_theme_auto: 'Automatisch',
  menu_theme_light: 'Licht',
  menu_theme_dark: 'Donker',
  menu_install: 'Installeren',
  menu_your_name: 'Jouw naam',
  menu_info: 'Over deze lijst',
  menu_manage: 'Links beheren',
  menu_delete_list: 'Lijst verwijderen',
  menu_shortcuts: 'Sneltoetsen',

  share_title: 'Delen',
  share_edit_tab: 'Samen bewerken',
  share_view_tab: 'Alleen bekijken',
  share_edit_warning: 'Iedereen met deze link kan de lijst bewerken.',
  share_view_warning: 'Iedereen met deze link kan meekijken, maar niets veranderen.',
  share_copy: 'Kopieer',
  share_copied: 'Gekopieerd',
  share_whatsapp: 'WhatsApp',
  share_more: 'Delen…',
  share_qr: 'QR-code',
  share_qr_hint: 'Laat scannen om mee te doen.',
  share_self_tip: 'Stuur de link ook naar jezelf, dan raak je hem niet kwijt.',

  manage_title: 'Links beheren',
  manage_admin_warning:
    'Deze beheerlink is de enige manier om de lijst te verwijderen of een gelekte link te vervangen. Houd hem privé.',
  manage_rotate_edit: 'Nieuwe bewerklink maken',
  manage_rotate_view: 'Nieuwe kijklink maken',
  manage_rotate_warning: 'De oude link werkt daarna niet meer.',
  manage_rotated: 'Nieuwe link gemaakt.',

  info_created: 'Gemaakt op {date}',
  info_expires: 'Verloopt op {date} als er niets mee gebeurt',
  info_items: '{count} items',

  view_only_banner: 'Je bekijkt deze lijst. Vraag de maker om de bewerklink om mee te doen.',
  view_only_toast: 'Dit is een alleen-lezen link.',

  connection_live: 'Live verbonden',
  connection_saving: 'Opslaan…',
  connection_reconnecting: 'Opnieuw verbinden…',
  connection_offline_edit:
    'Geen verbinding. Je wijzigingen worden opgeslagen zodra je weer online bent.',
  connection_offline_view: 'Geen verbinding. Dit is de laatst bekende versie.',

  undo: 'Ongedaan maken',
  toast_item_deleted: '‘{text}’ verwijderd',
  toast_items_added: '{count} items toegevoegd',
  toast_completed_cleared: '{count} afgestreepte items gewist',
  toast_unchecked_all: '{count} items uitgevinkt',
  toast_copied: 'Link gekopieerd',
  toast_text_copied: 'Lijst gekopieerd als tekst',
  toast_remote_cleared: 'Iemand heeft {count} afgestreepte items gewist',
  toast_remote_changed: 'Iemand anders heeft deze lijst gewijzigd',
  toast_item_gone: 'Dit item is door iemand anders verwijderd',
  toast_save_failed: 'Kon niet opslaan: {reason}',
  toast_rate_limited: 'Even rustig aan, probeer het zo nog eens.',
  toast_update_available: 'Nieuwe versie beschikbaar',
  refresh: 'Vernieuwen',

  confirm_delete_list_title: 'Deze lijst verwijderen?',
  confirm_delete_list_body:
    'De lijst en alle items zijn dan weg. Dit kan niet ongedaan gemaakt worden.',
  confirm_delete_list_yes: 'Ja, verwijderen',
  confirm_clear_title: '{count} afgestreepte items wissen?',
  confirm_cancel: 'Annuleren',

  name_prompt_title: 'Hoe heet je?',
  name_prompt_body: 'Zo weten anderen wie wat meeneemt. Alleen op dit apparaat opgeslagen.',
  name_placeholder: 'Je naam',
  save: 'Opslaan',
  close: 'Sluiten',
  back: 'Terug',

  notfound_title: 'Deze lijst bestaat niet',
  notfound_body:
    'De link klopt niet, of de lijst is verwijderd. Lijsten waar lang niets mee gebeurt, verdwijnen vanzelf.',
  notfound_new: 'Nieuwe lijst maken',
  notfound_home: 'Naar de startpagina',
  error_title: 'Er ging iets mis',
  error_retry: 'Opnieuw proberen',
  load_failed: 'Kan de lijst niet laden',
  load_failed_body: 'Controleer je verbinding.',

  shortcuts_title: 'Sneltoetsen',
  shortcut_add: 'Ga naar het invoerveld',
  shortcut_toggle: 'Item afstrepen',
  shortcut_edit: 'Item bewerken',
  shortcut_move: 'Item verplaatsen',
  shortcut_delete: 'Item verwijderen',
  shortcut_help: 'Deze hulp',
} as const

export type MessageKey = keyof typeof nl
/** Every locale supplies a plain string for each key the Dutch source defines. */
export type Dictionary = Record<MessageKey, string>
